import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SettingsService} from '../../../../services/settings.service';
import {MetodosServicio} from 'src/app/_helpers/interfaces/metodos-servicio';
import {Aplicacion} from 'src/app/_models/aplicacion';


@Injectable()
export class AplicacionService extends MetodosServicio<Aplicacion> {

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'public/aplicacion', Aplicacion);
  }

  restartItem(): void {
    this.setItem(new Aplicacion());
  }

  /**
   * Método para obtener la aplicacion de una persona según su id
   * @param aplicacionID identificador de aplicacion
   */
  obtenerAplicacion(filtro: any): Observable<any> {
    return this.http.get(this.settings.URL_BASE + 'public/aplicacion/', filtro);
  }
}
